import { Components, Theme, hexToRgb } from '@mui/material';

const components: Components<Omit<Theme, 'components'>>['MuiSlider'] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => {
      const mainColor = palette.grayBackground.A40;
      return {
        '&.Mui-disabled': {
          '& > .MuiSlider-rail': {
            backgroundColor: hexToRgb(mainColor as string),
            opacity: '0.38'
          },
          '& > .MuiSlider-track': {
            backgroundColor: mainColor,
            border: 'none'
          },
          '& > .MuiSlider-thumb': {
            backgroundColor: mainColor
          },
          '& > .MuiSlider-mark': {
            backgroundColor: mainColor
          },
          '& > .MuiSlider-markActive': {
            backgroundColor: palette.mode === 'light' ? 'white' : 'black'
          }
        }
      };
    },
    colorPrimary: ({ theme: { palette } }) => {
      const mainColor =
        palette.mode === 'light' ? palette.primary.A100 : palette.primary.A60;
      return {
        '& > .MuiSlider-rail': {
          backgroundColor: hexToRgb(mainColor as string),
          opacity: '0.12'
        },
        '& > .MuiSlider-track': {
          backgroundColor: mainColor,
          border: 'none'
        },
        '& > .MuiSlider-thumb': {
          backgroundColor: mainColor
        },
        '& > .MuiSlider-mark': {
          backgroundColor: mainColor
        },
        '& > .MuiSlider-markActive': {
          backgroundColor: palette.mode === 'light' ? 'white' : 'black'
        }
      };
    },
    colorSecondary: ({ theme: { palette } }) => {
      const mainColor = palette.grayBackground.A100;
      return {
        '& > .MuiSlider-rail': {
          backgroundColor: hexToRgb(mainColor as string),
          opacity: '0.38'
        },
        '& > .MuiSlider-track': {
          backgroundColor: mainColor,
          border: 'none'
        },
        '& > .MuiSlider-thumb': {
          backgroundColor: mainColor
        },
        '& > .MuiSlider-mark': {
          backgroundColor: mainColor
        },
        '& > .MuiSlider-markActive': {
          backgroundColor: palette.mode === 'light' ? 'white' : 'black'
        }
      };
    }
  }
};
export default {
  components
};
